export class BackupPoliciesSecurityConfig {
    'policiesConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policiesConfig",
            "baseName": "policiesConfig",
            "type": "Array<BackupPolicySecurityConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPoliciesSecurityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
